/**
 * MuestraEstadoBadge — Badge de estado de muestra con color.
 *
 * Requirements: M4.15.4
 */

import { Badge } from "@/components/ui/badge";
import { getBadgeVariantMuestra } from "../utils/muestra-transitions";
import type { EstadoMuestra } from "@/hooks/use-muestras";

const ESTADO_LABELS: Record<EstadoMuestra, string> = {
  PENDIENTE: "Pendiente",
  TOMADA: "Tomada",
  INSUFICIENTE: "Insuficiente",
  RECHAZADA: "Rechazada",
  REPETIDA: "Repetida",
};

interface MuestraEstadoBadgeProps {
  estado: EstadoMuestra;
  estadoDisplay?: string;
}

export function MuestraEstadoBadge({ estado, estadoDisplay }: MuestraEstadoBadgeProps) {
  const variant = getBadgeVariantMuestra(estado);
  const label = estadoDisplay ?? ESTADO_LABELS[estado] ?? estado;

  return <Badge variant={variant}>{label}</Badge>;
}
